import { Component, Inject, ViewChild } from '@angular/core';
import { MatSnackBar, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { UsuarioComponent } from '../../usuario/usuario.component';
import { UsuarioService } from '../../../../providers/usuario.service';
import { AuthenticationService } from '../../../../providers/auth.service';

@Component({
  selector: 'app-editar-usuario-dialog',
  templateUrl: './editar-usuario-dialog.component.html',
  styleUrls: ['./editar-usuario-dialog.component.scss']
})
export class EditarUsuarioDialog {
  error: string = '';
  cargando: boolean = true;

  @ViewChild(UsuarioComponent) usuarioForm: UsuarioComponent;

  constructor(
    public dialogEditar: MatDialogRef<EditarUsuarioDialog>,
    private usuarioService: UsuarioService,
    private _authenticationService: AuthenticationService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar
  ) { }

  onUsuarioInput() { // si cambian los datos ingresados 
    this.error = ''; // limpiamos los mensajes de error del formulario
  }

  onFormState(formState: any): void { // escucha los diferentes estados del formulario
    if (formState.estado && formState.estado != 1) { // ocurrio un error en el formulario
      this.error = formState.mensaje;
    }

    if (typeof formState.cargando != undefined) {
      this.cargando = formState.cargando;
    }
  }

  onCancelar(): void {
    this.dialogEditar.close();
  }

  onEditar(): void {
    this.error = '';

    this.cargando = true;
    this.usuarioForm.getUsuario()
      .then(
        usuario => {
          this.usuarioService.editarUsuario(usuario).subscribe(
            respuesta => {
              if (respuesta.estado == 1) {
                this.snackBar.open(respuesta.mensaje, 'OK', { duration: 2750 });
                this.dialogEditar.close(respuesta);

                // si me edité a mi mismo, actualizo mis datos
                if (usuario.IdUsuario == this._authenticationService.IdUsuario) {
                  this._authenticationService.apellido = usuario.apellido;
                  this._authenticationService.nombre = usuario.nombre;
                  this._authenticationService.telefono = usuario.telefono;
                  this._authenticationService.puesto = usuario.puesto.descripcion;
                }
              } else {
                this.error = respuesta.mensaje;
              }

              this.cargando = false;
            },
            error => {
              this.cargando = false;
              this.error = error;
            });
        })
      .catch(
        error => {
          this.error = error;
          this.cargando = false;
        }
      );
  }
}
